import { useState, useCallback } from 'react';
import { Producto } from '../types';
import { ProductoService } from '../services';

interface UseInactivarProductoState {
  modalOpen: boolean;
  selectedProducto: Producto | null;
  loading: boolean;
  error: string | null;
}

export function useInactivarProducto() {
  const [state, setState] = useState<UseInactivarProductoState>({
    modalOpen: false,
    selectedProducto: null,
    loading: false,
    error: null,
  });

  const openModal = useCallback((producto: Producto) => {
    setState(prev => ({
      ...prev,
      modalOpen: true,
      selectedProducto: producto,
      error: null,
    }));
  }, []);

  const closeModal = useCallback(() => {
    setState(prev => ({
      ...prev,
      modalOpen: false,
      selectedProducto: null,
      error: null,
    }));
  }, []);

  const inactivar = useCallback(async (producto: Producto): Promise<void> => {
    setState(prev => ({
      ...prev,
      loading: true,
      error: null,
    }));

    try {
      await ProductoService.inactivarProducto(producto.id);

      setState(prev => ({
        ...prev,
        loading: false,
        modalOpen: false,
        selectedProducto: null,
      }));
    } catch (err: any) {
      const errorMessage =
        err.message === 'El producto ya fue desactivado'
          ? 'El producto ya fue desactivado'
          : err.message || 'Error al inactivar producto';

      setState(prev => ({
        ...prev,
        loading: false,
        error: errorMessage,
      }));

      throw err;
    }
  }, []);

  return {
    modalOpen: state.modalOpen,
    selectedProducto: state.selectedProducto,
    loading: state.loading,
    error: state.error,
    openModal,
    closeModal,
    inactivar,
  };
}
